import { useStore } from '@core/composables/use-store';
import {
  MediaLibraryOrigin,
  MediaLibraryOpenedEventProperties,
  MediaLibraryImportEventProperties,
  trackMediaLibraryOpened,
  trackMediaLibraryImport
} from '../analytics/events';

export function useMediaLibraryAnalytics() {
  const store = useStore();
  const brandId = store.getters['brand'].id;

  const trackDrawerOpened = (origin: MediaLibraryOrigin = MediaLibraryOrigin.Other) => {
    if (!brandId) {
      return;
    }

    const properties: MediaLibraryOpenedEventProperties = {
      brand_id: brandId,
      origin
    };

    trackMediaLibraryOpened(properties);
  };

  const trackImageImport = (fileCount: number) => {
    if (!brandId) {
      return;
    }

    const properties: MediaLibraryImportEventProperties = {
      brand_id: brandId,
      file_count: fileCount,
    };

    trackMediaLibraryImport(properties);
  };

  return {
    trackDrawerOpened,
    trackImageImport
  };
}
